export const TRIGGER_ADD_ENTITY = 'trigger-add-entity';
export const TRIGGER_REMOVE_ENTITY = 'trigger-remove-entity';
export const TRIGGER_SKILL_EXECUTED = 'trigger-skill-executed';
export const TRIGGER_MODIFIER_ADDED = 'trigger-modifier-added';
export const TRIGGER_ENEMY_WAVE_START = 'trigger-enemy-wave-start';
export const TRIGGER_GAME_FINISH = 'trigger-game-finish';
export const TRIGGER_WON = 'trigger-won';
export const TRIGGER_UPDATE_ENTITY_SPRITE = 'trigger-update-entity-sprite';
export const TRIGGER_SHIELD_EFFECT = 'trigger-shield-effect';
export const TRIGGER_INTRO_CENTRAL_BANK = 'trigger-intro-central-bank';
export const TRIGGER_GAME_INFLATION = 'trigger-game-inflation';
export const TRIGGER_WORKERS_ARRIVED = 'trigger-workers-arrived';
export const TRIGGER_GAME_PAUSED = 'trigger-game-paused';
export const TRIGGER_AGENT_INVISIBLE = 'trigger-agent-invisible';
export const TRIGGER_AGENT_KILLED = 'trigger-agent-killed';
export const TRIGGER_ENEMY_KILLED = 'trigger-enemy-killed';
export const TRIGGER_EXPLOSION = 'trigger-explosion';
export const TRIGGER_HEAVEN_FORCES_ARRIVED = 'trigger-heaven-forces-arrived';
export const TRIGGER_BOSS_SPAWNED = 'trigger-boss-spawned';
export const TRIGGER_COLOR_SCREEN = 'trigger-color-screen';
